import { render, staticRenderFns } from "./NotaryProductList.handler.vue?vue&type=template&id=3e010583&"
import script from "./NotaryProductList.handler.vue?vue&type=script&lang=ts&"
export * from "./NotaryProductList.handler.vue?vue&type=script&lang=ts&"
import style0 from "./NotaryProductList.handler.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports